<!-- 
  带上传附件的输入框（客户阶段的反馈在用）
 -->

<template>
  <div class="comment-box stage-comment-box" :class="{'active': true || open}"> <!-- 客户阶段这边目前都是打开状态，先写死,代码先不删，以后可能用到 -->
    <textarea
      v-model="textarea"
      ref="textArea"
      class="enter"
      placeholder="输入反馈内容..."
      @keyup="mention"
      @focus="openBox">
    </textarea>
    <div class="mention-result" v-show="mentionList.length">
      <ul>
        <li class="first">
          <span class="text">选择你要@的人</span>
        </li>
        <li
          class="me-item"
          v-for="(item, index) in mentionList"
          :key="item.id"
          :class="{actived: Mcurrent === index}"
          @click="selectMention(item)"
          @mouseover="changeCurrent(index)">
          <span class="text">{{item.value}}</span>
        </li>
      </ul>
    </div>
    <div class="options">
      <ul class="menu">
        <!-- 上传图片 -->
        <li class="opt-item">
          <el-badge 
          :hidden="images.length === 0"
          :value="images.length" class="item">
            <el-popover
              placement="bottom-start"
              title="上传图片"
              width="400"
              trigger="click">
              <el-upload
                class="img-box"
                ref="uploadImg"
                :action="uploadUlr"
                :data="uploadData"
                list-type="picture-card"
                :accept="imgAccept"
                :on-remove="imgRemove"
                :on-error="handleError"
                :on-success="imgAdd"
                :file-list="uploadImg"
                :limit="9"
                :before-upload="handleBeforeUpload"
                >
                <i class="el-icon-plus" @click="set_upload_param"></i>
              </el-upload>
                <i slot="reference" class="text web-icon-img"></i>
            </el-popover>
          </el-badge>
        </li>
        <li class="opt-item">
          <el-badge 
          :hidden="fileAttrValue.length === 0"
          :value="fileAttrValue.length" class="item">
            <el-popover
              placement="bottom-start"
              title="上传附件"
              width="400"
              trigger="click">
              <el-upload
                ref="uploadFile"
                :action="uploadUlr"
                :data="uploadData"
                :on-remove="fileRemove"
                :on-success="fileAdd"
                :on-error="handleError"
                :before-upload="handleBeforeUpload"
                :file-list="uploadFile"
                >
                <el-button class="text" size="small" type="primary" @click="set_upload_param">添加附件</el-button>
              </el-upload>
              <i slot="reference" class="text web-icon-file"></i>
            </el-popover>
          </el-badge>
        </li>
      </ul>
      <el-button size="small" class="submit" type="primary" @click="handleEmit">保存</el-button>
      <el-button size="small" class="cancel" @click="closeBox">取消</el-button>
    </div>
  </div>
</template>

<script>
import * as api from 'src/api'
import { Message } from 'element-ui'
import atSomeone from './at-someone'
import uploadMix from 'src/config/upload-mixin'

export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    defUserId: {
      type: String,
      required: false
    },
    refType: {
      type: String,
      required: true
    },
    refId: {
      type: Number,
      required: true
    },
    customerId: {
      type: Number,
      required: false
    }
  },
  data () {
    return {
      textarea: '',
      open: this.isOpen,
      fileAttrValue: [],
      images: []
    }
  },
  mixins: [atSomeone, uploadMix],
  methods: {
    // 展开
    openBox () {
      this.open = true
    },
    // 收回
    closeBox () {
      this.open = false
    },
    // 提交回复
    handleEmit () {
      if (this.textarea.length > 225) {
        Message('请把字数限制在225之内')
        return
      }
      let url = `/commentApi/save.html`
      let params = {
        customerId: this.customerId,
        refId: this.refId,
        refType: this.refType,
        content: this.textarea.replace(this.refName, ''),
        attachment: this.fileAttrValue,
        refUserId: this.refUserId,
        images: this.images
      }
      api.post(url, params, (data) => {
        this.fileAttrValue = []
        this.images = []
        this.textarea = ''
        this.open = false
        Message({
          type: 'success',
          message: data.msg || '操作成功!'
        })
        this.$refs.uploadFile.clearFiles() // 这里清空上传文件列表和上传图片列表
        this.$refs.uploadFile.abort()
        this.$refs.uploadImg.clearFiles()
        this.$refs.uploadImg.abort()
        this.$emit('refresh')
      })
    },
    // 判断文件名或uid，有任意一个则视为相等
    fileRemove (file) {
      if (file) {
        let arr = this.fileAttrValue
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].attachIndex === file.url || arr[i].uid === file.uid) {
            arr.splice(i, 1)
          }
        }
      }
    },
    fileAdd (response, file) {
      let newFile = {
        filename: file.name,
        attachIndex: this.fileUrl[file.uid],
        ext: file.name.replace(/.+\./, '').toLowerCase(),
        size: file.size,
        uid: file.uid,
        name: file.name
      }
      this.fileAttrValue.push(newFile)
    },
    // 移除图片
    imgRemove (file) {
      if (file) {
        this.images.forEach((item, index) => {
          if (item.uid === file.uid) {
            this.images.splice(index, 1)
          }
        })
      }
    },
    // 上传图片
    imgAdd (response, file) {
      this.images.push({url: this.fileUrl[file.uid], uid: file.uid, name: file.name})
    }
  }
}
</script>
<style lang="less">
.stage-comment-box {
  .opt-item {
    position: relative;
    .el-upload-list {
      position: absolute;
      background: #fff;
      min-width: 200px;
      .el-upload-list__item {
        border: 1px solid #d2d2d2;
        border-top: 0;
        border-bottom: 0;
      }
      .el-upload-list__item:first-child {
        border-top: 1px solid #d2d2d2;
      }
      .el-upload-list__item:last-child {
        border-bottom: 1px solid #d2d2d2;
      }
    }
  }
}
</style>
<style lang="less" scoped>
 @import '../../../assets/less/variable.less';
  .comment-box {
    .options {
      position: relative;
      background:#f5f9ff;
      height:44px;
      .menu {
        padding: 13px 0 0 18px;
        /deep/.el-badge__content {
          background-color:#6a82a4;
          height: 14px;
          line-height: 14px;
          padding: 0px 4px;
          font-size: 10px;
        }
        .opt-item {
          display: inline-block;
          font-size: 13px;
          padding-right: 48px;
          &:first-child {
            padding-top: 1px;
            padding-bottom: 1px;
          }
          &:last-child {
            border-right-width: 0;
          }
          &.required::after {
            content: "*";
            position: absolute;
            color: red;
            left: 10px;
            top: 2px;
          }
          .text {
            word-break: break-all;
            cursor: pointer;
            color: #C4D1EB;
            font-size: 18px;
          }
        }
      }
      .submit {
        position: absolute;
        top: 7px;
        right: 80px;
        padding: 6px 15px;
      }
      .cancel {
        position: absolute;
        top: 7px;
        right: 10px;
        padding: 6px 15px;
      }
    }
    &.active {
      .enter {
        height: 62px;
      }
      .btn-group {
        display: block;
      }
    }
    .enter {
      display: block;
      resize: none;
      box-sizing: border-box;
      background:#ffffff;
      border:1px solid #e5ecf7;
      border-radius:2px;
      padding: 7px;
      font-size: 13px;
      height: 32px;
      width: 100%;
      transition: height 0.5s;
      color: #666;
    }
    .mention-result {
      position: absolute;
      left: 16px;
      top: 78px;
      z-index: 50;
      width: 200px;
      background-color: #fff;
      box-shadow: 0 0 4px 0 rgba(114, 114, 114, 0.5);
      padding: 2px;
      border-radius: 2px;
      overflow: auto;
      font-size: 13px;
      .first {
        padding: 5px 10px;
      }
      .me-item {
        padding: 8px 10px;
        cursor: pointer;
        &:hover, &.actived {
          background-color: #f3f5f7;
          color: @bg-orange;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// stage-comment-box.vue?33baa17a